
import { useOverlayData } from "../hooks/useOverlayData";

import Timer from "./Timer";
import LowerThird from "./LowerThird";
import EventAlert from "./EventAlert";
import "../styles/overlay.css"; // CSS var theme styles
import { useParams } from "react-router-dom";
import ScorebugSets from "./ScorebugSets";
import { Box, Grid } from "@mui/material";
import ScorebugSolves from "./ScorebugSolves";

const OverlayRoot = () => {
  const { id } = useParams();
  const { player, opponent, loading, error } = useOverlayData(id!);

  return (
    <div className={`overlay-root theme-default}`}>
      <Box
        position="fixed"
        top={0}
        left={0}
        width="100%"
        px={0}
        py={0}
        bgcolor="transparent"
      >
        <Grid container spacing={0}>
          <Grid item xs={12} display="flex" justifyContent="center">

            <Box
              height="95vh"
              width="10px"
              px={"1px"}
              py={"1px"}
              bgcolor="#cccccc"
              zIndex={0}
            >
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box
        position="fixed"
        top={0}
        left={0}
        width="100%"
        px={0}
        py={0}
        bgcolor="transparent"
      >
        <ScorebugSets scale={20} title="SOLVES WON" awayScore={opponent.wins} awayName={opponent.name} homeScore={player.wins} homeName={player.name} />
        <Box height={"6px"}/>
        <ScorebugSolves scale={18} awayScore={"--"} homeScore={"--"} />
      </Box>


      <Box
        position="fixed"
        bottom={0}
        left={0}
        width="100%"
        px={0}
        py={0}
        bgcolor="transparent"
      >
        <ScorebugSets scale={16} title="SETS WON"  awayScore={opponent.sets} awayName={opponent.name} homeScore={player.sets} homeName={player.name}  />
      </Box>
      {/* <Timer seconds={data.timer} />
      {data.lowerThird && <LowerThird {...data.lowerThird} />}
      {data.eventMessage && <EventAlert message={data.eventMessage} />} */}
    </div>
  );
};

export default OverlayRoot;